// removed by extract-text-webpack-plugin
module.exports = {"root":"Map__root__3sHx2","mapRoot":"Map__mapRoot__3U6lW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Map/Map.css
// module id = 2022
// module chunks = 0